var isScriptNode = function isScriptNode(node) {
  return node.tagName === "SCRIPT";
};
var isExternalScript = function isExternalScript(node) {
  return !!node.src && node.src !== "";
};
var cloneScriptNode = function cloneScriptNode(node) {
  var script = document.createElement("script");
  script.text = node.innerHTML;
  for (var i = node.attributes.length - 1; i >= 0; i--) {
    script.setAttribute(node.attributes[i].name, node.attributes[i].value);
  }
  return script;
};
export var replaceScriptNode = function replaceScriptNode(node) {
  if (isScriptNode(node) && !isExternalScript(node)) {
    if (node.parentNode) {
      node.parentNode.replaceChild(cloneScriptNode(node), node);
    }
  } else {
    var i = 0;
    var children = node.childNodes;
    while (i < children.length) {
      replaceScriptNode(children[i++]);
    }
  }
  return node;
};